import { useMemo } from "react";

import { useAllCompanyLocations } from "~/modules/client/api/companyLocation/companyLocationQueries.ts";
import type { FormInputOption } from "~/types/form.ts";
import { createInputOptionData,getInputDefaultOptionsData } from "~/utils/form/formUtils.ts";
import { byObjectProperty } from "~/utils/sortFunctions.ts";


const useCompanyLocationSelectOptions = (includeCtaOption: boolean = false): FormInputOption[] => {
	const { data: companyLocationsData } = useAllCompanyLocations();
	return useMemo(() => {
		if (companyLocationsData) {
			const companyLocationsSorted = [...companyLocationsData].sort(byObjectProperty("listPosition"));
			const options = companyLocationsSorted.map((companyLocation) => {
				const label = companyLocation.location.displayName;
				return createInputOptionData(label, companyLocation.id);
			});

			if (includeCtaOption) {
				return [getInputDefaultOptionsData(), ...options];
			}
			return options;
		}
		return [];
	}, [companyLocationsData, includeCtaOption]);
};

export default useCompanyLocationSelectOptions;

